import Head from './../components/Head';
import Footer from './../components/Footer';
import Course from './components/Course';
import ResourceCenter from './components/ResourceCenter.vue';
import SpocCourse from './components/SpocCourse.vue';
import TeacherList from './components/TeacherList';
import BannerList from './components/BannerList';
import News from './components/News';
import TeacherData from './components/TeachData.vue';
import Link from '../components/aboutLink.vue';
import TeachingCenterList from './components/TeachingCenterList.vue';
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    Footer,
    SpocCourse,
    TeacherData,
    Link,
    ResourceCenter,
    TeachingCenterList
  },

  created() {
    this.getDataList(); // this.getLive();
  },

  mounted() {
    this.token = this.$utils.getCookie('jt-cas');
  },

  unmounted() {
    this.zhsHelper.destory();
  },

  data() {
    return {
      menuCode: '10301',
      dataList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      moocItem: null,
      newsItem: null,
      teacherItem: null,
      teachingCenterItem: null,
      menuInfo: {},
      userInfo: null,
      zhsRole: 0,
      zhsHelper: null,
      token: ''
    };
  },

  methods: {
    isLogin() {
      const host = window.location.protocol + '//' + window.location.host; // const loginUrl = host + '/index.html'

      const url = host + '/index.html';
      window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${url}&source=${this.$schoolId}`;
    },

    async getDataList() {
      const res = await this.$http.getDataList();
      console.log('首页数据', res);
      this.dataList = res;
      this.footerItem = this.dataList.find(item => item.menu_code == '10303');
      this.dataItem = this.dataList.find(item => item.menu_code == '10304');
      this.bannerItem = res.find(item => item.menu_code == '10302');
      this.moocItem = res.find(item => item.menu_code == '10401');
      this.newsItem = res.find(item => item.menu_code == '10701');
      this.teacherItem = res.find(item => item.menu_code == '10501');
      this.teachingCenterItem = res.find(item => item.menu_code == '30200');
    },

    // async getLive() {
    //   const res = await this.$http.getHomeLive();
    //   // console.log('首页直播', res)
    //   this.liveList = res;
    // },
    getUserInfo(data) {
      this.userInfo = data;
      console.log(this.userInfo);
    },

    getZhsRole(data) {
      this.zhsRole = data || 0;
      this.getZhsAi(this.token); // console.log(this.zhsRole);
    },

    getZhsAi(token) {
      if (this.zhsRole && this.zhsRole != 3) {
        this.zhsHelper = new zhsAiToolHelper(token);
      }
    }

  }
};